// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2pbio","empty":"ModalGraph_empty__24PqI"};